import './vendor.js';
import './../sass/style.scss';
import 'bootstrap';
import fontawesome from '@fortawesome/fontawesome';
import light from '@fortawesome/fontawesome-pro-light';
import Flickity from 'flickity';
import 'lightgallery/dist/js/lightgallery-all';

import noUiSlider from 'nouislider';

import wNumb from './wnumb-1.1.0/wNumb';

fontawesome.library.add(light);

(function () {
	"use strict";

	var $ = jQuery;
	$(document).ready(function(){
		$('.gallery').lightGallery({
			selector: '.gallery-item a'
		});

		//mobile header nav click toggles also
		$('.navbar-header').click(function(event) {
	    	if ($(event.target).hasClass('navbar-header') || $(event.target).hasClass('navbar-brand')) {
	    		$(this).find('.navbar-toggle').click();
	    	}
	    });

		

		//module gallery fancybox
		// $(".m-gallery__items a").fancybox({
		// 	padding : 0,
		// 	margin : [0,100,0,100],
		// 	openEffect: 'fade',
		// 	closeEffect: 'fade',
		// });

		//arrow jumpers
		$('.m-videobanner__jumparrow, .m-imagebanner__jumparrow, .m-slidebanner__jumparrow').click(function(event){
			var $root = $('html, body');
			var $elem = $(this);
			$root.animate({
				scrollTop: $elem.offset().top
			}, 1000);
		});

		//range slider
		rangeDropdownsToSlider();
		$('.casawp-filterform').on( "casawp-filterform:after-filter-reload", function(event, url, filteredUrl){
			console.log('hello world');
			rangeDropdownsToSlider();
		});

		function rangeDropdownsToSlider(){
			if($('.casawp-filterform-pricecount-2')){
				$('.casawp-filterform-pricecount-2').each(function(idx, priceWrapperElem){
					const $priceWrapperElem = $(priceWrapperElem);
					const $fromElem = $priceWrapperElem.find("select[name=price_from]");
					const $toElem = $priceWrapperElem.find("select[name=price_to]");
					if ($fromElem.length && $toElem.length) {
						let fromVal = $fromElem.find("option:first-child").val();
						if (!fromVal) {
							//the first item ist often a mask
							fromVal = $fromElem.find("option:nth-child(2)").val();
						}
						const toVal = $toElem.find("option:last-child").val();
						if (fromVal && toVal) {
							$fromElem.replaceWith('<input type="number" name="price_from" value="'+$fromElem.val()+'" />');
							$toElem.replaceWith('<input type="number" name="price_to" value="'+$toElem.val()+'" />');

							const values = $fromElem.find('option').map(function() { return ($(this).val() ? parseInt($(this).val()) : 0); }).get();
							let range = {};
							values.forEach((value, idx) => {
								if (idx === 0) {
									range.min = value;
								} else if((idx+1) === values.length){
									range.max = value;
								} else {
									range[(idx*(100/values.length))+"%"] = value;
								}
							});
							console.log(range);

							const $rFromElem = $priceWrapperElem.find("input[name=price_from]");
							const $rToElem = $priceWrapperElem.find("input[name=price_to]");

							$priceWrapperElem.find('div').not('.casawp-filterform-duo-label').hide();
							$priceWrapperElem.find('.casawp-filterform-duo-label').show();

							const $rangeSliderControl = $('<div class="form-control form-control-slider"><div class="noUi-placeholder" /></div>');
							$priceWrapperElem.append($rangeSliderControl);

							const sliderElem = $rangeSliderControl.find('.noUi-placeholder')[0];


							noUiSlider.create(sliderElem, {
								start: [
									(parseInt($fromElem.val()) ? parseInt($fromElem.val()) : 0),
									(parseInt($toElem.val()) ? parseInt($toElem.val()) : toVal)
								],
								connect: true,
								snap: true,
								range: range,
								pips: {
									mode: 'positions',
									values: [0,50,100],
									density: 3,
									// filter: ( value, type ) => {
									// 	return value % 1000 ? 2 : 1;
									// },
									format: wNumb({
										decimals: 0,
										prefix: 'CHF ',
										thousand: '\'',
									}),
									stepped: true,
								}

							});

							sliderElem.noUiSlider.on('change', ( values, handle ) => {
								var value = values[handle];

								if ( handle === 0 ) {
									$rFromElem.val(Math.round(parseInt(value)));
								} else {
									$rToElem.val(Math.round(parseInt(value)));
								}

								$('.casawp-filterform').change();
							});
						}
					}
				})
			}
		}


	});

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js